
export default {
    Activity : "activity",
    Influencers : "influencers",
    Followers: "followers"
};
